import { useMemo } from "react";

import { PERMISSIONS } from "../../types/auth";
import { useAuth } from "../AuthContext";
import { checkPermission } from "./permissionHelper";

/**
 * Custom hook to check if the user has a permission
 * @param permission - The permission to check for
 * @returns True if the user has the permission, false otherwise
 */
export const useHasPermission = (permission: PERMISSIONS) => {
  const { user } = useAuth();

  const userHasPermission = useMemo(() => {
    return checkPermission(permission, user);
  }, [user, permission]);

  return userHasPermission;
};
